import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import { API_ENDPOINT } from '../../../constants';
import xIcon from '../../../assets/svg/x.svg';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'

import checkIcon from '../../../assets/svg/check-icon.svg';
import calendar from '../../../assets/svg/calendar.svg';
import clockIcon from '../../../assets/svg/clock-icon.svg'


import Checkbox from '../../../components/forms/fields/checkbox';
import { getDetailedGroupPaymentMethods, getGroupPaymentMethods, getHumanReadable, getHumanReadableReasonForChange, getReasonsForChange } from '../helper';
import ErrorModal from '../../../components/errorModal';
import InfoModal from '../../../components/infoModal';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class SwishModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            originalPaymentReference: '',
            identifier: ''
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }


    get = () => {

    }
    getPaymentData = () => {
        const paymentId = this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/patient/payments/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const paymentData = result?.paymentData ?? null;
                const caseData = result?.caseData ?? null;
                const groupData = result?.groupData ?? null;
                const eventData = result?.eventData ?? null;
                if (!paymentData || paymentData?.currentStatus?.status?.key !== 'UNPAID') {
                    this.onClose();
                    return;
                }
                this.setState({ paymentData: paymentData, caseData: caseData, groupData: groupData, eventData: eventData }, () => {
                    this.setInitialData();
                })
            })
        } else {
            this.onClose();
        }
    }
    setInitialData = () => {
        const data = this.getMainData();

        let formData = {
            payer: data?.patientPhoneNumber,
            amount: data?.priceAmount,
            message: data?.caseNumber
        };

        this.setState({
            formData,
            currentStatus: '',
            originalPaymentReference: "",
            identifier: "",
            initialData: { ...data }
        })
    }
    getMainData = () => {
        const { paymentData, caseData, groupData, eventData } = this.state;
        const currency = this.getCurrency();
        const caseNumber = paymentData?.paymentNumber ?? '';
        const patientPhoneNumber = this.getPatientPhoneNumber();
        const fullPatientPhoneNumber = patientPhoneNumber ? `+${patientPhoneNumber}` : '';
        const priceAmount = paymentData?.amount?.value ?? 0;
        const priceCurrency = paymentData?.amount?.currency ?? currency;
        const price = `${priceAmount} ${priceCurrency}`;

        const clinicGroupBankAccount = groupData?.canUseSwishForPayment && groupData?.bankAccount ? groupData?.bankAccount : null;




        let response = {
            priceAmount: priceAmount,
            priceCurrency: priceCurrency,
            price: price,
            caseNumber: caseNumber,
            patientPhoneNumber: patientPhoneNumber,
            clinicGroupBankAccount: clinicGroupBankAccount,
            fullPatientPhoneNumber: fullPatientPhoneNumber
        };

        return response;
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }


    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }

    }


    getPatientPhoneNumber = (value) => {
        const userData = this.props.uData;
        let phone = value ?? userData?.phone;
        if (!phone) return null;
        if (phone.indexOf('+') === 0) {
            phone = phone.replace('+', '')
        } else if (phone.indexOf('00') === 0) {
            phone = phone.replace(/^00/, '')
        } else if (phone.indexOf('0') === 0) {
            phone = phone.replace(/^0/, '')
        }

        if (phone.indexOf('+00') === 0) {
            phone = phone.replace('+00', '+')
        } else if (phone.indexOf('+0') === 0) {
            phone = phone.replace('+0', '+')
        }

        phone = phone.replace(/[^0-9]/g, '')

        if (phone.indexOf('46') !== 0) {
            phone = '46' + phone;
        }


        return phone;
    }

    startPayment = () => {

        const formData = this.state.formData;
        const paymentData = this.state.paymentData;
        const paymentId = paymentData?._id;
        if (!paymentId) {
            return;
        }

        const data = {
            paymentId: paymentId,
            payer: formData?.payer,
            amount: formData?.amount,
            message: formData?.message
        }
        for (var key in data) {
            if (!data[key]) {
                this.setState({ error: 'Missing data'.translate(this.props.lang) })
                return;
            }
        }
        this.setState({ loading: true }, () => {
            fetch(API_ENDPOINT + `/api/payments/swish/start-payment`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loading: false }, () => {
                    if (result?.error) {
                        const error = result?.details?.[0]?.errorMessage ?? result.error;
                        let currentStatus = `${'Request failure: '.translate(this.props.lang)}${error?.translate(this.props.lang)}`;
                        this.setState({ currentStatus: currentStatus })
                    } else if (result?.success) {
                        if (result?.status === 'CREATED' && result?.id) {
                            let setObj = {
                                identifier: result.id,
                                currentStatus: 'Open your Swish app to confirm payment.'.translate(this.props.lang),
                                loading: true
                            }
                            this.setState(setObj, () => {
                                this.checkPaymentStatus();
                            })
                        }
                    }
                })
            })
        })
    }
    paymentDoneSuccessfully = () => {
        if (this.props.onSuccessfullyPayment) {
            this.props.onSuccessfullyPayment();
        }
    }

    checkPaymentStatus = () => {
        const identifier = this.state.identifier;
        if (!identifier) {
            this.setState({ currentStatus: "No payment Id".translate(this.props.lang), loading: false });
            return;
        }
        fetch(API_ENDPOINT + `/api/payments/swish/check-status/${identifier}`, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(parseJSON).then(({ result, status }) => {
            const _status = result?.status ?? null;
            if (_status === 'PAID') {
                const paymentReference = result?.paymentReference ?? '';
                let setObj = {
                    originalPaymentReference: paymentReference,
                    currentStatus: 'Payment successful!'.translate(this.props.lang),
                    loading: false
                };
                this.setState(setObj, () => {
                    this.paymentDoneSuccessfully();
                });
            } else {
                setTimeout(() => {
                    this.checkPaymentStatus();
                }, 2000);
            }

        })
    }

    getBasicInfo = () => {
        const { paymentData, caseData, groupData, eventData } = this.state;

        const currency = this.getCurrency();
        const _dateFormat = paymentData?.caseData?.visitDate?.hideTimeFromThePatient ? this.props.dateFormat : `${this.props.dateFormat} HH:mm`;
        const _visitDateTs = paymentData?.caseData?.visitDate?.ts ?? null;
        const visitDate = _visitDateTs ? this.props.getStringDateTs(_visitDateTs, _dateFormat) : null;
        const doctorName = paymentData?.caseData?.doctorName ? paymentData?.caseData?.doctorName : !paymentData?.caseData && paymentData?.createdByUser?.name ? paymentData?.createdByUser?.name : null;
        const questionaryName = paymentData?.caseData?.questionaryName ?? '';
        const caseNumber = paymentData?.paymentNumber ?? '';
        const patientName = paymentData?.patientData?.name ?? '';
        const patientSSN = paymentData?.patientData?.ssn ?? '';
        const price = `${paymentData?.amount?.value} ${paymentData?.amount?.currency ?? currency}`;

        let duration;
        if (eventData?.startTime && eventData?.endTime) {
            duration = Math.floor((eventData?.endTime - eventData?.startTime) / 60);
        }
        if (!duration && caseData?.questionaryDuration) {
            duration = caseData?.questionaryDuration;
        }
        if (caseData?.wayOfScheduling !== 'webBooking') {
            duration = null;
        }


        const questionaryDuration = duration ?? null;

        let response = {
            questionaryName: questionaryName,
            price: price,
            caseNumber: caseNumber,
            patientName: patientName,
            patientSSN: patientSSN,
            visitDate: visitDate,
            doctorName: doctorName,
            questionaryDuration: questionaryDuration
        };

        return response;
    }



    render() {
        const isOpen = this.props.isOpen;
        const paymentData = this.state.paymentData;

        const basicInfo = this.getBasicInfo();

        if (!paymentData) {
            return null;
        }

        return (
            <>
                <Modal isOpen={isOpen} centered className='swish-payment-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Swish Payment'.translate(this.props.lang)}

                    </ModalHeader>

                    <ModalBody>
                        <Row>
                            <Col lg='12'>
                                <div className='basic-info-wrap'>
                                    {
                                        basicInfo?.visitDate ?
                                            <div className='info-item'>
                                                <div className='icon-wrap'>
                                                    <Isvg src={calendar} />
                                                </div>
                                                <div className='text-wrap'>
                                                    <div className='text-item' style={{ display: 'flex', gap: 10 }}>
                                                        <span>{basicInfo.visitDate}</span>
                                                        <span className='sub-text'>{"Timezone: Stockholm".translate(this.props.lang)}</span>
                                                    </div>
                                                    {
                                                        basicInfo?.doctorName ?
                                                            <div className='text-item'>
                                                                <span>{basicInfo.doctorName}</span>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        basicInfo?.questionaryName || (!basicInfo?.visitDate && basicInfo?.doctorName) ?
                                            <div className='info-item'>
                                                <div className='icon-wrap'>
                                                    <Isvg src={checkIcon} />
                                                </div>
                                                <div className='text-wrap'>
                                                    <div className='text-item'>
                                                        <span>{basicInfo.questionaryName}</span>
                                                    </div>
                                                    {
                                                        basicInfo?.questionaryDuration ?
                                                            <div className='text-item'>
                                                                <span className='sub-text'>{`${basicInfo.questionaryDuration} ${'min'.translate(this.props.lang)}`}</span>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        !basicInfo?.visitDate && basicInfo?.doctorName ?
                                                            <div className='text-item'>
                                                                <span>{basicInfo.doctorName}</span>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </Col>

                            <Col lg='12'>
                                <div className='swish-payment-info'>
                                    {/* <div className='swish-payment-title'>{'Swish Payment'.translate(this.props.lang)}</div> */}
                                    <FormGroup>
                                        <Label>{'Your Swish mobile number'.translate(this.props.lang)}</Label>
                                        <Input
                                            type='text'
                                            value={this.state.initialData?.fullPatientPhoneNumber ?? ''}
                                            onChange={(e) => {
                                                let value = e.target.value.replace(/[A-Za-z]/g, '');
                                                let setObj = {};
                                                let initialData = this.state.initialData;
                                                initialData.fullPatientPhoneNumber = value;

                                                let patientPhoneNumber = this.getPatientPhoneNumber(value);
                                                initialData.patientPhoneNumber = patientPhoneNumber;

                                                let formData = this.state.formData;
                                                formData.payer = patientPhoneNumber;
                                                setObj.initialData = initialData;
                                                setObj.formData = formData;

                                                this.setState(setObj);
                                            }}
                                        />
                                    </FormGroup>
                                    <div className='swish-payment-details-wrap'>
                                        <div className='swish-payment-detail'>
                                            {/* <div className='swish-payment-detail-label'>{'Amount:'.translate(this.props.lang)}</div>
                                            <div className='swish-payment-detail-value'>{this.state.formData?.amount ?? ''} kr.</div> */}
                                        </div>
                                        <div className='swish-payment-detail'>
                                            <div className='swish-payment-detail-label'>{'Reference'.translate(this.props.lang)}</div>
                                            <div className='swish-payment-detail-value'>{this.state.formData?.message ?? ''}</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>


                            <Col lg='12'>
                                <div className='total-price-wrap'>
                                    <div className='total-price'>{basicInfo?.price}</div>
                                </div>
                            </Col>

                        </Row>



                        <div className='modal-footer-buttons-wrap'>
                            <Button
                                color="primary"
                                onClick={() => this.startPayment()}
                                disabled={this.state.loading}
                                className='pay-button'
                            >
                                {'Start payment'.translate(this.props.lang)}
                            </Button>

                            {
                                this.state.currentStatus ?
                                    <div className='swish-payment-status'>{this.state.currentStatus}</div>
                                    :
                                    null
                            }
                            <Button color="primary" className='red-button' onClick={() => this.onClose()}>{'Cancel'.translate(this.props.lang)}</Button>


                            {/* <Button
                                color="primary"
                                onClick={() => this.startPayment()}
                                disabled={this.state.loading}
                                className='swish-start-payment-button'
                            >
                                {'Start payment'.translate(this.props.lang)}
                            </Button> */}

                            {
                                this.state.loading ?
                                    <Player
                                        autoplay={true}
                                        loop={true}
                                        src="/lf30_editor_l5cxzdyf.json"
                                        style={{ height: "256px", width: "256px", position: 'absolute', top: "50%", left: '50%', transform: 'translate(-50%, -50%)' }}
                                    ></Player>
                                    :
                                    null
                            }

                        </div>


                    </ModalBody>

                </Modal>


                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}

            </>
        );
    }
}


export default SwishModal;